import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/historial_orden_trabajo/addHistorialOrdenTrabajo.php';

export default function addHistorialOrdenTrabajo({values}){
    const idUsuario = localStorage.getItem("idUsuario")
    values = {...values, id: idUsuario}
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}